<template>
  <div
    class="modal fade"
    id="viewImageModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="viewImageModalLabel"
    aria-hidden="true"
    ref="modalEle"
  >
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="viewImageModalLabel">
            {{ name }}
          </h5>
          <button
            class="btn-close"
            type="button"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="card papernote-wrap">
            <div class="card-body pt-0">
              <div class="text-center">
                <img
                  class="img-fluid"
                  :src="imageUrl"
                  :alt="name"
                  style="max-height: 500px; width: auto"
                />
              </div>
              <div class="mt-3 text-center">
                <p class="text-muted">
                  {{ name }} del evento: <strong>{{ event?.title }}</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Modal } from "bootstrap";
import { computed, ref, onMounted } from "vue";

const props = defineProps({
  event: Object,
  name: String,
  mode: String,
});

const baseServerUrl = process.env.VUE_APP_SERVER_SIDE_URL;

const modalEle = ref(null);
let modalObj = null;

onMounted(() => {
  modalObj = new Modal(modalEle.value);
});

function _show() {
  modalObj.show();
}

const name = computed(() => {
  return props.name;
});

const event = computed(() => {
  return props.event;
});

const imageUrl = computed(() => {
  let imgPath = "commons/default.jpg";

  if (!props.event) return imgPath;

  switch (props.mode) {
    case "poster":
      if (props.event.poster) imgPath = props.event.poster;
      break;
    case "banner":
      if (props.event.banner) imgPath = props.event.banner;
      break;
    case "regulation":
      if (props.event.regulation) imgPath = props.event.regulation;
      break;
  }

  return `${baseServerUrl}/${imgPath}`;
});

defineExpose({ show: _show });
</script>

<style scoped>
.img-fluid {
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.papernote-wrap {
  border: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
</style>
